/**
 * 404 Error Page - Designed for consistency with app auth and billing layouts
 */
import { Typography, Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Home, ArrowBack } from "@mui/icons-material";
import { isAuthenticated } from "@/utils/localStorage";

export default function Error404Page() {
	const navigate = useNavigate();
	const authenticated = isAuthenticated();

	return (
		<div className="flex min-w-0 flex-auto flex-col items-center justify-center p-4">
			<div className="bg-white min-h-full w-full rounded-none px-4 py-12 sm:min-h-auto sm:w-auto sm:max-w-md sm:rounded-xl sm:px-12 sm:py-14 sm:shadow-sm">
				<div className="flex flex-col items-center text-center">
					{/* 404 Number - Large, muted, with subtle styling */}
					<Box
						component="span"
						sx={{
							display: "block",
							fontSize: { xs: "6rem", sm: "8rem" },
							fontWeight: 700,
							lineHeight: 1,
							background: "linear-gradient(135deg, #000000 0%, #bc9709 65%)",
							backgroundClip: "text",
							WebkitBackgroundClip: "text",
							WebkitTextFillColor: "transparent",
							letterSpacing: "-0.02em",
						}}
					>
						404
					</Box>

					<Typography
						variant="h5"
						className="mt-4 font-semibold"
						sx={{ color: "text.primary" }}
					>
						Page not found
					</Typography>
					<Typography
						variant="body1"
						className="mt-2 max-w-sm"
						sx={{ color: "text.secondary" }}
					>
						The page you’re looking for doesn’t exist or has been moved. Check the
						URL or head back to the home.
					</Typography>

					{/* Action buttons */}
					<div className="mt-10 flex flex-col-reverse gap-3 sm:flex-row sm:gap-4">
						<Button
							variant="outlined"
							color="secondary"
							startIcon={<ArrowBack />}
							onClick={() => navigate(-1)}
							sx={{
								textTransform: "none",
								fontWeight: 600,
								borderColor: "rgba(0, 0, 0, 0.23)",
								"&:hover": {
									borderColor: "#ffca00",
									backgroundColor: "rgba(255, 202, 0, 0.15)",
								},
							}}
						>
							Go back
						</Button>
						<Button
							variant="contained"
							color="secondary"
							startIcon={<Home />}
							onClick={() =>
								navigate(authenticated ? "/dashboard" : "/sign-in", {
									replace: true,
								})
							}
							sx={{
								textTransform: "none",
								fontWeight: 600,
							}}
						>
							{authenticated ? "Dashboard" : "Sign in"}
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
}
